import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { ModalType } from './types';

export interface UsersAdminState {
  activeModal: ModalType | null;
}

const initialState: UsersAdminState = {
  activeModal: null,
};

const courtsSlice = createSlice({
  name: 'courts',
  initialState,
  reducers: {
    changeActiveModal: (state, action: PayloadAction<ModalType | null>) => {
      state.activeModal = action.payload;
      if (action.payload === null) {
        state.activeModal = null;
      }
    },
  }
});

export const selectCourtsActiveModal = (state: RootState) => state.courts.activeModal;

export const { changeActiveModal: changeCourtsActiveModal } = courtsSlice.actions;
export { courtsSlice };
